import $ from 'jquery';

function init () {
}

$(document).ready(function () {
  init()
})
